/**
 * Client-side superAdmin gating. THIS IS UI-ONLY.
 *
 * The real authorization lives server-side (backend/utils/superAdmin.js). The
 * localStorage flag below merely decides whether the affordance renders for
 * the one pinned identity — a malicious user flipping it just gets 403s.
 * Never treat it as a security boundary.
 */

export const SUPERADMIN_EMAIL = 'jennyguo490@gmail.com';
const LS_KEY = 'lanura.superAdmin';

/**
 * Environments where superAdmin tooling must stay reachable regardless of the
 * account's billing state: local dev and the dev subdomain. Used to keep the
 * superAdmin on /settings (admin panels, Stripe mode toggle) when billing
 * 402s would otherwise bounce them to /subscription — on these hosts the
 * subscription state is routinely absent/broken by design (test Stripe,
 * mode switching), and Settings is where the fix lives.
 */
export function isDevHost(): boolean {
  try {
    const h = window.location.hostname;
    return h === 'localhost' || h === '127.0.0.1' || h === 'dev.lanura.ai';
  } catch {
    return false;
  }
}

/** Only the one pinned owner identity may ever see the affordance. */
export function isSuperAdminClient(user: any): boolean {
  return (
    !!user &&
    user.role === 'owner' &&
    String(user.email || '')
      .trim()
      .toLowerCase() === SUPERADMIN_EMAIL
  );
}

/** Enabled only if the identity matches AND the session toggle is on. */
export function isSuperAdminEnabled(user: any): boolean {
  if (!isSuperAdminClient(user)) return false;
  try {
    return localStorage.getItem(LS_KEY) === '1';
  } catch {
    return false;
  }
}

export function setSuperAdminEnabled(on: boolean): void {
  try {
    if (on) localStorage.setItem(LS_KEY, '1');
    else localStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
}

/** Cleared on logout so it never persists across accounts/sessions. */
export function clearSuperAdmin(): void {
  try {
    localStorage.removeItem(LS_KEY);
  } catch {
    /* ignore */
  }
}
